var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.11,
    height: 12.111,
    viewBox: "0 0 12.11 12.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffd355;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1.888)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.888)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.191,53.714a.939.939,0,0,0-1.419,0c-.332.329-.663.658-.99.992a.2.2,0,0,1-.273.05c-.215-.117-.443-.212-.65-.34a10.292,10.292,0,0,1-2.481-2.258,5.878,5.878,0,0,1-.889-1.425.2.2,0,0,1,.05-.262c.332-.321.655-.65.981-.979a.942.942,0,0,0,0-1.452c-.259-.262-.519-.519-.778-.781s-.532-.538-.8-.8a.945.945,0,0,0-1.419,0c-.335.329-.655.666-1,.99a1.615,1.615,0,0,0-.507,1.09,4.618,4.618,0,0,0,.357,1.988A12.078,12.078,0,0,0,2.516,54.1,13.266,13.266,0,0,0,6.91,57.536a6.354,6.354,0,0,0,2.434.708,1.784,1.784,0,0,0,1.53-.583c.284-.318.6-.608.906-.912a.948.948,0,0,0,.006-1.444Q10.991,54.507,10.191,53.714Z",
    transform: "translate(-0.006 -46.137)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPhone);
export default __webpack_public_path__ + "static/media/Footer_phone.cb58d6dd4781e57d0e3113740d168e15.svg";
export { ForwardRef as ReactComponent };